import { render, staticRenderFns } from "./otherPage.vue?vue&type=template&id=5a6dc44d&scoped=true&"
import script from "./otherPage.vue?vue&type=script&lang=js&"
export * from "./otherPage.vue?vue&type=script&lang=js&"
import style0 from "./otherPage.vue?vue&type=style&index=0&id=5a6dc44d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6dc44d",
  null
  
)

export default component.exports